import {
  Activity,
  Banknote,
  FileBarChart,
  GitCompareArrows,
  ShieldCheck,
  Wallet,
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/nucleo/utilitarios';

export const SOF_ABAS = [
  { caminho: '/operacao/financeiro/sof/reservas', titulo: 'Reservas', icone: Wallet },
  { caminho: '/operacao/financeiro/sof/status', titulo: 'Status', icone: Activity },
  { caminho: '/operacao/financeiro/sof', titulo: 'Lotes SOF', icone: Banknote },
  {
    caminho: '/operacao/financeiro/sof/conciliacao',
    titulo: 'Conciliação',
    icone: GitCompareArrows,
  },
  { caminho: '/operacao/financeiro/sof/relatorios', titulo: 'Relatórios', icone: FileBarChart },
  { caminho: '/operacao/financeiro/sof/historico', titulo: 'Histórico', icone: ShieldCheck },
] as const;

/** FIN-030/031: barra de abas do hub SOF, replicada em cada uma das 6 telas
 * (protótipo mantém as 6 abas visíveis em qualquer sub-rota do hub). Mesmo
 * capsule usado nas abas de Fechamento Mensal V2 — `data-[state=active]`
 * do Tabs do design system não pega aqui porque isto navega por rota, não
 * por estado local, então a classe ativa é decidida em JS. */
export function SofTabsNav() {
  const { pathname } = useLocation();
  return (
    <nav
      aria-label="Operações SOF"
      className="flex w-max max-w-full gap-1 overflow-x-auto rounded-2xl border border-border/40 bg-muted/50 p-1 backdrop-blur-xs"
    >
      {SOF_ABAS.map(({ caminho, titulo, icone: Icon }) => {
        const ativa = pathname === caminho;
        return (
          <Link
            key={caminho}
            to={caminho}
            className={cn(
              'flex shrink-0 items-center gap-2 rounded-xl px-4 py-2 text-sm text-muted-foreground transition-all duration-200 hover:bg-background/50 hover:text-foreground',
              ativa && 'bg-card font-semibold text-foreground shadow-xs dark:bg-primary/10',
            )}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
            {titulo}
          </Link>
        );
      })}
    </nav>
  );
}
